export default __webpack_public_path__ + "static/media/static-compra.1101b543.svg";